import dayjs from "dayjs"

// RangePicker
export function disableAntdPickerDates( current ) {
    // Can not select days after today
    return current && current > dayjs().endOf('day');
}